import { useState, useEffect } from 'react';
import moment from 'moment';

import Loading from "../../components/Loading";
import Data from '../../../repository';

import styles from '../../../styles/Admin.module.scss';

const cardStyle = { background: '#ffffff', padding: '40px', borderRadius: '0 0 6px 6px', marginTop: 0, width: '100%' };

function List() {
	const [loading, setLoading] = useState(true);
	const [users, setUsers] = useState([]);
	const [clearingId, setClearingId] = useState(null);

	useEffect(() => {
		refresh();
	}, []);

	const refresh = async () => {
		setLoading(true);
		try {
			const res = await Data.fetchHealthScreeningUsers();
			setUsers(res.data);
		} catch (error) {
			console.error('Error fetching health screening submissions:', error);
		}
		setLoading(false);
	};

	const handleClear = async (userId) => {
		setClearingId(userId);
		try {
			await Data.clearHealthScreening(userId);
			await refresh();
		} catch (error) {
			console.error('Error clearing health screening:', error);
		} finally {
			setClearingId(null);
		}
	};

	if (loading) return <Loading button={false} />;

	return (
		<div style={cardStyle}>
			{!users.length && <p>No health screening forms have been completed yet.</p>}

			{users.length > 0 && (
				<div className={styles.tableWrap}>
					<table style={{ width: '100%', borderCollapse: 'collapse' }}>
						<thead>
							<tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
								<th style={{ padding: '8px' }}>Name</th>
								<th style={{ padding: '8px' }}>Email</th>
								<th style={{ padding: '8px' }}>Completed</th>
								<th style={{ padding: '8px' }}>Flagged</th>
								<th style={{ padding: '8px' }}>Status</th>
								<th style={{ padding: '8px' }} />
							</tr>
						</thead>
						<tbody>
							{users.map((user) => {
								const flagged = !!user.healthScreening?.hasConcerns;
								const cleared = !!user.healthScreening?.clearedAt;
								return (
									<tr key={user._id} style={{ borderBottom: '1px solid #f0f0f0' }}>
										<td style={{ padding: '8px' }}>{user.firstName} {user.lastName}</td>
										<td style={{ padding: '8px' }}>{user.email}</td>
										<td style={{ padding: '8px' }}>{moment(user.healthScreening?.completedAt).format('ddd, MMM D, YYYY')}</td>
										<td style={{ padding: '8px' }}>
											<span className={styles.statusPill} style={{ background: flagged ? '#fdeceaff' : '#e8f5ee', color: flagged ? '#c0392b' : '#217a45' }}>
												{flagged ? 'Yes' : 'No'}
											</span>
										</td>
										<td style={{ padding: '8px' }}>
											{!flagged ? 'Clear to book' : cleared ? `Cleared ${moment(user.healthScreening.clearedAt).format('MMM D, YYYY')}` : 'Awaiting review'}
										</td>
										<td style={{ padding: '8px', textAlign: 'right' }}>
											{flagged && !cleared && (
												<button
													type="button"
													className="btn btnPrimary"
													style={{ width: 'auto' }}
													disabled={clearingId === user._id}
													onClick={() => handleClear(user._id)}
												>
													{clearingId === user._id ? 'Clearing...' : 'Clear to book'}
												</button>
											)}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
}

export default List;
